import { lazy } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import LocaleShell from './LocaleShell';
import LegacyLocaleRedirect from './LegacyLocaleRedirect';

const HomePage = lazy(() => import('../pages/home/page'));
const CozumlerPage = lazy(() => import('../pages/cozumler/page'));
const LogoPage = lazy(() => import('../pages/cozumler/logo/page'));
const LogosoftPage = lazy(() => import('../pages/cozumler/logosoft/page'));
const LogosoftOrtakligiPage = lazy(() => import('../pages/cozumler/logosoft-ortakligi/page'));
const SAPBusinessOnePage = lazy(() => import('../pages/cozumler/sap-business-one/page'));
const BoyumITPage = lazy(() => import('../pages/cozumler/boyum-it/page'));
const ComputecPage = lazy(() => import('../pages/cozumler/computec/page'));
const CoresystemsPage = lazy(() => import('../pages/cozumler/coresystems/page'));
const HuaweiRedirect = lazy(() => import('../pages/cozumler/huawei/page'));
const DNAsoftPage = lazy(() => import('../pages/cozumler/dnasoft/page'));
const DNAsoftCafPage = lazy(() => import('../pages/cozumler/dnasoft/caf/page'));
const DNAsoftKafPage = lazy(() => import('../pages/cozumler/dnasoft/kaf/page'));
const YapayZekaPage = lazy(() => import('../pages/cozumler/yapay-zeka/page'));
const HizmetlerPage = lazy(() => import('../pages/hizmetler/page'));
const UrunlerPage = lazy(() => import('../pages/urunler/page'));
const ProIntercompanyPage = lazy(() => import('../pages/urunler/prointercompany/page'));
const ProBIPage = lazy(() => import('../pages/urunler/probi/page'));
const ProBankPage = lazy(() => import('../pages/urunler/probank/page'));
const ProHRPage = lazy(() => import('../pages/urunler/prohr/page'));
const ProMESPage = lazy(() => import('../pages/urunler/promes/page'));
const ProMobilePage = lazy(() => import('../pages/urunler/promobile/page'));
const IletisimPage = lazy(() => import('../pages/iletisim/page'));
const HakkimizdaPage = lazy(() => import('../pages/hakkimizda/page'));
const GizlilikPage = lazy(() => import('../pages/yasal/gizlilik/page'));
const CerezlerPage = lazy(() => import('../pages/yasal/cerezler/page'));
const CampaignLandingPage = lazy(() => import('../pages/kampanya/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const DestekIndirPage = lazy(() => import('../pages/destek/indir/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const localeChildren: RouteObject[] = [
  { index: true, element: <HomePage /> },
  { path: 'cozumler', element: <CozumlerPage /> },
  { path: 'cozumler/logo', element: <LogoPage /> },
  { path: 'cozumler/logosoft', element: <LogosoftPage /> },
  { path: 'cozumler/logosoft-ortakligi', element: <LogosoftOrtakligiPage /> },
  { path: 'cozumler/sap-business-one', element: <SAPBusinessOnePage /> },
  { path: 'cozumler/boyum-it', element: <BoyumITPage /> },
  { path: 'cozumler/computec', element: <ComputecPage /> },
  { path: 'cozumler/coresystems', element: <CoresystemsPage /> },
  { path: 'cozumler/huawei', element: <HuaweiRedirect /> },
  { path: 'cozumler/dnasoft', element: <DNAsoftPage /> },
  { path: 'cozumler/dnasoft/caf', element: <DNAsoftCafPage /> },
  { path: 'cozumler/dnasoft/kaf', element: <DNAsoftKafPage /> },
  { path: 'cozumler/yapay-zeka', element: <YapayZekaPage /> },
  { path: 'hizmetler', element: <HizmetlerPage /> },
  { path: 'urunler', element: <UrunlerPage /> },
  { path: 'urunler/prointercompany', element: <ProIntercompanyPage /> },
  { path: 'urunler/probi', element: <ProBIPage /> },
  { path: 'urunler/probank', element: <ProBankPage /> },
  { path: 'urunler/prohr', element: <ProHRPage /> },
  { path: 'urunler/promes', element: <ProMESPage /> },
  { path: 'urunler/promobile', element: <ProMobilePage /> },
  { path: 'iletisim', element: <IletisimPage /> },
  { path: 'destek/indir', element: <DestekIndirPage /> },
  { path: 'hakkimizda', element: <HakkimizdaPage /> },
  { path: 'yasal/gizlilik', element: <GizlilikPage /> },
  { path: 'yasal/cerezler', element: <CerezlerPage /> },
  { path: 'kampanya/:slug', element: <CampaignLandingPage /> },
  { path: '*', element: <NotFoundPage /> },
];

const routes: RouteObject[] = [
  { path: '/', element: <Navigate to="/tr" replace /> },
  { path: '/admin', element: <AdminPage /> },
  {
    path: '/tr',
    element: <LocaleShell lang="tr" />,
    children: localeChildren,
  },
  {
    path: '/en',
    element: <LocaleShell lang="en" />,
    children: localeChildren,
  },
  {
    path: '*',
    element: <LegacyLocaleRedirect />,
  },
];

export default routes;
